import { useTranslation } from 'react-i18next';
import { EU_LANGUAGES, LanguageCode } from '@/lib/languages';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Globe } from 'lucide-react';

export default function LanguageSelector() {
  const { i18n } = useTranslation();
  
  const currentLang = i18n.language as LanguageCode;
  const currentLangData = EU_LANGUAGES[currentLang] || EU_LANGUAGES.en;

  const changeLanguage = (lang: LanguageCode) => {
    i18n.changeLanguage(lang);
    // Mark as manually selected so IP detection doesn't override
    localStorage.setItem('languageManuallySelected', 'true');
    // Update HTML lang attribute for SEO
    document.documentElement.lang = lang;
  };

  // Show only main languages in dropdown for UX, but all are supported
  const mainLanguages: LanguageCode[] = ['it', 'en', 'de', 'fr', 'es', 'nl', 'pl', 'pt'];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-2">
          <Globe className="w-4 h-4" />
          <span className="hidden sm:inline">{currentLangData.name}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="max-h-80 overflow-y-auto">
        {mainLanguages.map((lang) => (
          <DropdownMenuItem
            key={lang}
            onClick={() => changeLanguage(lang)}
            className={lang === currentLang ? 'bg-accent' : ''}
          >
            {EU_LANGUAGES[lang].name}
          </DropdownMenuItem>
        ))}
        <div className="border-t my-1" />
        {(Object.keys(EU_LANGUAGES) as LanguageCode[])
          .filter(lang => !mainLanguages.includes(lang))
          .map((lang) => (
            <DropdownMenuItem
              key={lang}
              onClick={() => changeLanguage(lang)}
              className={lang === currentLang ? 'bg-accent' : ''}
            >
              {EU_LANGUAGES[lang].name}
            </DropdownMenuItem>
          ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
